// hubs/components/Logo.tsx
import * as React from 'react';
import {Grid, Theme, Tooltip, Typography} from '@material-ui/core';
import {createStyles, withStyles} from '@material-ui/core/styles';

const styles = ({spacing}: Theme) => createStyles({
    text: {
        marginBottom: spacing(2),
        marginTop: spacing(4),
    }
});

const Logo = (props: any) => {
    const {classes} = props;

    return (
        <Grid item xs={12}>
            <Tooltip title='HUBS Operations'>
                <Typography align='center' variant='h2' className={classes.text}>
                    HUBS Operations
                </Typography>
            </Tooltip>
        </Grid>
    );
};

export default withStyles(styles)(Logo);
